import { render, staticRenderFns } from "./VenScLAddress_List.vue?vue&type=template&id=2ef9021a"
import script from "./VenScLAddress_List.vue?vue&type=script&lang=js"
export * from "./VenScLAddress_List.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports